module.exports = __webpack_public_path__ + "img/PS13.6b99b6ea.png";